var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckedBaggageIncluded = function SvgCheckedBaggageIncluded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2C8 1.44772 8.44772 1 9 1H15C15.5523 1 16 1.44772 16 2V4.17647H17C18.6569 4.17647 20 5.51962 20 7.17647V19C20 20.6569 18.6569 22 17 22C17 22.5523 16.5523 23 16 23C15.4477 23 15 22.5523 15 22H9C9 22.5523 8.55228 23 8 23C7.44772 23 7 22.5523 7 22C5.34315 22 4 20.6569 4 19V7.17647C4 5.51962 5.34314 4.17647 7 4.17647H8V2ZM10 4.17647H14V3H10V4.17647ZM7 6.17647C6.44772 6.17647 6 6.62419 6 7.17647V19C6 19.5523 6.44772 20 7 20H17C17.5523 20 18 19.5523 18 19V7.17647C18 6.62419 17.5523 6.17647 17 6.17647H7ZM10 8C10.5523 8 11 8.44772 11 9V17C11 17.5523 10.5523 18 10 18C9.44772 18 9 17.5523 9 17V9C9 8.44772 9.44772 8 10 8ZM14 8C14.5523 8 15 8.44772 15 9V17C15 17.5523 14.5523 18 14 18C13.4477 18 13 17.5523 13 17V9C13 8.44772 13.4477 8 14 8Z",
    fill: "#1D1D1D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 6,
    fill: "#44B50C",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9834 18.4403L16.0608 17.4095C15.8318 17.1537 15.4452 17.1378 15.1972 17.3738C14.9492 17.6099 14.9338 18.0086 15.1627 18.2644L16.5729 19.8399C16.8285 20.1254 17.2712 20.1067 17.5034 19.8007L20.3709 16.0194C20.5788 15.7453 20.5318 15.3492 20.2659 15.1348C20.0001 14.9204 19.616 14.9688 19.4081 15.243L16.9834 18.4403Z",
    fill: "white"
  })));
};
export default SvgCheckedBaggageIncluded;